import React from 'react';

const WhiteCard = (props) => {
    const { content, heading, isContent, childClassName = "" } = props;
    if (!isContent) {
        return <></>
    }
    return (
        <div className="whiteCard">
            <h2>{heading}</h2>
            <div className={`cardInfoSection ${childClassName ? childClassName : ''}`}>
                {content}
            </div>
        </div>
    )
}

export default WhiteCard;
